
export class FilteredSelectOptionsRequest {
    configFile: string;
    selectFrom: string;
    optionFilter: string;
    limit: number;

    constructor( configFile: string, selectFrom: string, optionFilter: string, limit: number ) {
        this.configFile = configFile;
        this.selectFrom = selectFrom;
        this.optionFilter = optionFilter;
        this.limit = limit;
    }
}
